import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { tokens } from '@/design/tokens'

// Supply Chain Value Creator Theme - Light Mode
const lightTheme = {
  dark: false,
  colors: {
    // The palette is the design tokens (src/design/tokens.ts). Tailwind reads
    // the same values as CSS variables, so the React shell and the Vue islands
    // render one product.
    primary: tokens.color.primary,
    secondary: tokens.color.secondary,
    accent: tokens.color.accent,
    background: tokens.color.background,
    surface: tokens.color.surface,
    error: tokens.color.error,
    info: tokens.color.primary,
    success: tokens.color.primary,
    warning: tokens.color.warning,

    // Extended Palette
    'purple': '#9c27b0',        // Material Design purple (for simulation buttons)
    'deep-purple': '#6a1b9a',  // For simulation button
    'blue-lighten-1': '#3399ff',
    'blue-lighten-2': '#66b3ff',
    'blue-darken-1': '#0052a3',
    'blue-darken-2': '#003d7a',
    'green-darken-1': '#0052a3',  // Changed to dark blue for consistency
    'orange-darken-1': '#e68900',

    // Grays for UI elements
    'grey-lighten-5': '#f8f9fa',
    'grey-lighten-4': '#e9ecef',
    'grey-lighten-3': '#dee2e6',
    'grey-lighten-2': '#ced4da',
    'grey-darken-1': '#6c757d',
    'grey-darken-2': '#495057',
    'grey-darken-3': '#343a40',
  }
}

// Supply Chain Value Creator Theme - Dark Mode
const darkTheme = {
  dark: true,
  colors: {
    // Primary Brand Colors - Lighter for dark mode
    primary: '#4da3ff',        // Lighter blue
    secondary: '#00a3ff',      // Keep accent
    accent: '#80c4ff',         // Very light blue

    // Functional Colors
    background: '#121212',     // Dark background
    surface: '#1E1E1E',        // Dark surface
    error: '#CF6679',          // Material dark error
    info: '#4da3ff',           // Lighter blue
    success: '#66BB6A',        // Material dark success
    warning: '#FFB74D',        // Material dark warning

    // Extended Palette
    'purple': '#BA68C8',         // Material Design purple (for simulation buttons)
    'deep-purple': '#B388FF',
    'blue-lighten-1': '#82B1FF',
    'blue-lighten-2': '#448AFF',
    'blue-darken-1': '#2979FF',
    'blue-darken-2': '#2962FF',
    'green-darken-1': '#00E676',
    'orange-darken-1': '#FFAB40',

    // Grays for UI elements
    'grey-lighten-5': '#1E1E1E',
    'grey-lighten-4': '#2C2C2C',
    'grey-lighten-3': '#333333',
    'grey-lighten-2': '#424242',
    'grey-darken-1': '#757575',
    'grey-darken-2': '#9E9E9E',
    'grey-darken-3': '#BDBDBD',
  }
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
      darkTheme
    }
  },
  icons: {
    defaultSet: 'mdi'
  }
})
